module.exports = __webpack_public_path__ + "img/tutorial-pc-page4.5b752cc0.png";